import React from 'react';
import { ToggleSwitch } from '@boatsetter-backup/js-component-lib';
import styled from 'styled-components';
import { Trans } from '@lingui/react';

interface Props {
  checked: boolean;
  setChecked: any;
}

const InstantBookableFilter = React.memo(({ checked, setChecked }: Props) => {
  const changeInstantBookable = () => {
    setChecked((prev) => !prev);
  };

  return (
    <Wrapper>
      <Heading>
        <Trans id="instantBookableFilter.instantBook" />
      </Heading>
      <ToggleWrapper>
        <ToggleSwitch isActive={checked} onChange={changeInstantBookable} onLabel="" offLabel="" />
      </ToggleWrapper>
    </Wrapper>
  );
});

export default InstantBookableFilter;

const Heading = styled.div`
  font-size: 100%;
  line-height: 1.4;
  color: #17233c;
  font-weight: 400;
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ToggleWrapper = styled.div`
  cursor: pointer;
`;
